<template>
    <div>
        <b-row>
            <b-col>
                <h5 class="text-secondary">Suppressed</h5>
            </b-col>

            <b-col align="right">
                <b-button @click="addSuppress" variant="outline-secondary" size="sm" tabindex="-1">
                    <b-icon-plus></b-icon-plus>
                </b-button>
            </b-col>
        </b-row>

        <b-row v-if="!component.length">
            <b-col align="center">
                <b-list-group>
                    <b-list-group-item variant="light">
                        <small><em>No Suppressed Sites</em></small>
                    </b-list-group-item>
                </b-list-group>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <b-row v-for="(suppress, index) in component" :key="index">
                    <b-col>
                        <b-input-group size="sm">
                            <b-form-select v-model="suppress.site"
                                           :options="suppressSiteList"
                                           :ref="'site-' + index"
                                           @change="changeSite(suppress.site, index)"
                                           :state="suppress.site && suppress.site.length ? null : false">
                                <template #first>
                                    <b-form-select-option :value="null" disabled>Site</b-form-select-option>
                                </template>
                            </b-form-select>

                            <b-input-group-append v-if="suppress.date">
                                <b-button size="sm" :id="'suppressdate-' + index" variant="outline-info" tabindex="-1">
                                    <b-icon-calendar4-event></b-icon-calendar4-event>
                                </b-button>

                                <b-tooltip :target="'suppressdate-' + index" triggers="hover">
                                    {{ moment(suppress.date).format('M/D/YYYY h:mma') }}
                                </b-tooltip>
                            </b-input-group-append>

                            <b-input v-model="suppress.reason"
                                     :state="suppress.reason && suppress.reason.length ? null : false"
                                     :ref="'reason-' + index"
                                     placeholder="Reason"></b-input>

                            <b-input-group-append>
                                <b-button size="sm" variant="outline-secondary" @click="removeSuppress(index)" tabindex="-1">
                                    <b-icon-x></b-icon-x>
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import arrayMixin from "../../mixins/array";
    import suppressSiteList from "../../assets/suppressSiteList";

    export default {
        name: "Suppressed",
        props: [ 'suppressed' ],
        mixins: [ arrayMixin, suppressSiteList ],
        created() {
            this.clone(this.suppressed);
        },
        data() {
            return {
            }
        },
        methods: {
            changeSite(type, index) {
                if (type) {
                    this.$nextTick(() => {
                        let ref = 'reason-' + index;

                        this.$refs[ref][0].$el.focus();
                    });
                }
            },
            addSuppress() {
                this.component.push({
                    site: null,
                    date: new Date().toISOString(),
                });

                this.$nextTick(() => {
                    let ref = 'site-' + (this.component.length - 1);

                    this.$refs[ref][0].$el.focus();
                });
            },
            removeSuppress(index) {
                this.component.splice(index, 1);
            }
        }
    }
</script>

<style scoped>

</style>